import React, { useRef } from 'react';

import { getUserPlatform } from '@bringg-frontend/utils';

import { useScroll } from '../../../hooks';

import styles from './scroll-bar.module.scss';

interface Props {
	height: number;
	scrollHeight: number;
	showScrollBar?: boolean;
}

const MAC_BAR_WIDTH = 14;
const WIN_BAR_WIDTH = 18;

const ScrollBar = ({ height, scrollHeight, showScrollBar }: Props) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const innerScrollRef = useRef<HTMLDivElement>(null);

	useScroll(innerScrollRef.current, containerRef.current);

	const platform = getUserPlatform();

	const width = platform === 'macOs' ? MAC_BAR_WIDTH : WIN_BAR_WIDTH;

	return (
		<div className={styles.scrollBar} style={!showScrollBar ? { visibility: 'hidden' } : undefined}>
			<div ref={containerRef} style={{ height, overflowY: 'auto', position: 'absolute', width, left: -width }}>
				<div ref={innerScrollRef} style={{ height: scrollHeight }} />
			</div>
		</div>
	);
};

export default ScrollBar;
